import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  Container,
  Card,
  Form,
  Row,
  Col,
  ButtonGroup,
  Button,
} from "react-bootstrap";
import { ThreeDots } from 'react-loader-spinner';
import { resetList, getCompanyID, updateCompany, updateCompanyID, addCompany, deleteCompanyID } from "../../3.Store/CompanySlice";

const CompanyForm = () => {
  const { cid } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector(state => state.CompanySlice.loading);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const company = useSelector(state => state.CompanySlice.company);
  const { id, description, short_description } = company;

  useEffect(() => {
    console.log("Company ID:", cid);
    window.scrollTo(0, 0);
    if (cid) {
      dispatch(getCompanyID({cid}))
        .catch((err) => {
          console.error("Failed to fetch company details:", err);
        });
    } else {
      dispatch(resetList());
    }
  }, [cid]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleBtnAdd = () => {
    const entity = { ...company };
    console.log(entity);
    dispatch(addCompany(entity))
      .unwrap()
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Company added successfully",
          confirmButtonColor: "#4fa94d",
        }).then(() => {
          dispatch(resetList());
          navigate("/Company");
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: (error.response.data || error.message),
          confirmButtonColor: "#4fa94d",
        });
      });
  };

  const handleBtnBack = () => {
    dispatch(resetList());
    navigate("/Company");
  };

  const handleUpdate = (e) => {
    const entity = { ...company, [e.target.name]: e.target.value };
    console.log(entity);
    dispatch(updateCompany(entity));
  };

  const handleBtnUpdate = () => {
    const entity = { ...company };
    console.log(entity);
    dispatch(updateCompanyID(entity))
      .unwrap()
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Company updated successfully",
          confirmButtonColor: "#4fa94d",
        }).then(() => {
          dispatch(resetList());
          navigate("/Company");
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: (error.response.data || error.message),
          confirmButtonColor: "#4fa94d",
        });
      });
  };

  const handleBtnDelete = () => {
    Swal.fire({
      title: 'Do you want to delete this company?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        const entity = { ...company };
        console.log(entity);
        dispatch(deleteCompanyID(entity))
          .unwrap()
          .then(() => {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Company deleted successfully",
              confirmButtonColor: "#4fa94d",
            }).then(() => {
              dispatch(resetList());
              navigate("/Company");
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: (error.response.data || error.message),
              confirmButtonColor: "#4fa94d",
            });
          });
      }
    });
  };

  return (
    <Container className="ContainerContent">
      {loading && (
        <ThreeDots
          visible={loading}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent2">

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>

        <h1 className="TitleHeader">Company</h1>
        <h1 className="MiniTitleHeader">{cid ? "Edit" : "Add"}</h1>

        <Row className="my-3">
          <Col md={12} sm={12}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Short Description</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="short_description" value={short_description} onChange={handleUpdate}/>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={12} sm={12}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Description</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="description" value={description} onChange={handleUpdate}/>
              </Col>
            </Row>
          </Col>
        </Row>

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
          &nbsp; &nbsp;
          <ButtonGroup className="my-2">
            {cid ? (
              <>
              <Button className="Button" onClick={handleBtnDelete}>
                Delete
              </Button>
              &nbsp; &nbsp;
              <Button className="Button" onClick={handleBtnUpdate}>
                Update
              </Button>
              </>
            ) : (
              <Button className="Button" onClick={handleBtnAdd}>
                Add
              </Button>
            )}
          </ButtonGroup>
        </div>
      </Card>
    </Container>
  );
};

export default CompanyForm;